import { render, staticRenderFns } from "./MGateList.vue?vue&type=template&id=6fd7f7da&scoped=true"
import script from "./MGateList.vue?vue&type=script&lang=js"
export * from "./MGateList.vue?vue&type=script&lang=js"
import style0 from "./MGateList.vue?vue&type=style&index=0&id=6fd7f7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7f7da",
  null
  
)

export default component.exports